/*
 * REMTUNE OIL PAN ADD-ONS
 * Checkbox add-ons that go into the cart as separate line items (own SKU / stock / price).
 * Markup comes from snippets/oil-pan-addons.liquid.
 *
 * - If no add-on box is ticked, this script leaves the theme's add to cart alone (it still keeps the
 *   Subtotal line in step with the selected pan).
 * - If one or more boxes are ticked, it adds the pan + the add-ons in ONE /cart/add.js request, then
 *   sends the customer to the cart. Shopify adds all of them or none of them.
 * - Drain line rows only show for pan variants with a turbo bung (any option value containing "turbo").
 */
(function () {
  'use strict';

  var roots = [];

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + n;
  }

  function init(root) {
    var form = root.closest('form');
    if (!form) return null;

    var idField = form.querySelector('[name="id"]');
    var sectionId = root.getAttribute('data-section-id');
    var productJsonEl = document.getElementById('ProductJson-' + sectionId);
    var product = null;
    try { product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch (e) { product = null; }

    var state = { root: root, form: form, idField: idField, product: product, lastId: null, busy: false };

    function currentVariant() {
      if (!product || !idField) return null;
      var id = String(idField.value);
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === id) return product.variants[i];
      }
      return null;
    }

    function isTurbo(variant) {
      if (!variant) return false;
      var opts = variant.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (/turbo/i.test(String(opts[i]))) return true;
      }
      return false;
    }

    function quantity() {
      var q = form.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function checkedBoxes() {
      var out = [];
      var boxes = root.querySelectorAll('[data-addon-check]');
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].checked && !boxes[i].disabled) out.push(boxes[i]);
      }
      return out;
    }

    function refresh() {
      var variant = currentVariant();
      var turbo = isTurbo(variant);

      var gated = root.querySelectorAll('[data-requires-turbo="true"]');
      for (var i = 0; i < gated.length; i++) {
        var row = gated[i];
        var box = row.querySelector('[data-addon-check]');
        if (turbo) {
          row.hidden = false;
          if (box) box.disabled = false;
        } else {
          row.hidden = true;
          if (box) { box.checked = false; box.disabled = true; }
        }
      }

      var boxes = checkedBoxes();
      // Keep the theme's Subtotal line in step: pan + every ticked add-on, times quantity.
      var subEl = form.querySelector('[data-total-price]');
      if (subEl && variant) {
        var sum = variant.price;
        for (var j = 0; j < boxes.length; j++) {
          sum += parseInt(boxes[j].getAttribute('data-price-cents'), 10) || 0;
        }
        subEl.textContent = money(sum * quantity());
        subEl.setAttribute('data-price-value', sum);
      }
    }

    function showError(message) {
      var wrap = form.querySelector('[data-error-message-wrapper]');
      var msg = form.querySelector('[data-error-message]');
      if (msg) msg.textContent = message;
      if (wrap) wrap.classList.remove('product-form__error-message-wrapper--hidden');
    }

    function clearError() {
      var wrap = form.querySelector('[data-error-message-wrapper]');
      if (wrap) wrap.classList.add('product-form__error-message-wrapper--hidden');
    }

    function setBusy(on) {
      state.busy = on;
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.disabled = on;
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
      }
    }

    function addAll() {
      if (state.busy) return;
      var variant = currentVariant();
      if (!variant) { showError('Please choose your engine and configuration.'); return; }

      var qty = quantity();
      var items = [{ id: variant.id, quantity: qty }];
      var boxes = checkedBoxes();
      for (var i = 0; i < boxes.length; i++) {
        var ids = (boxes[i].getAttribute('data-variant-ids') || '').split(',');
        for (var k = 0; k < ids.length; k++) {
          var vid = parseInt(ids[k], 10);
          if (vid) items.push({ id: vid, quantity: qty });
        }
      }

      clearError();
      setBusy(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      }).then(function (result) {
        if (result.ok) {
          var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root_ + 'cart';
        } else {
          setBusy(false);
          showError((result.data && (result.data.description || result.data.message)) ||
            'Sorry, that could not be added to your cart. Nothing was added.');
        }
      }).catch(function () {
        setBusy(false);
        showError('Sorry, that could not be added to your cart. Nothing was added.');
      });
    }

    state.refresh = refresh;
    state.addAll = addAll;
    state.checkedBoxes = checkedBoxes;

    root.addEventListener('change', refresh);
    form.addEventListener('change', refresh);
    form.addEventListener('click', function () { setTimeout(refresh, 0); });

    // The theme changes the hidden variant <select> from script; poll as a safety net.
    setInterval(function () {
      var id = idField ? idField.value : null;
      if (id !== state.lastId) { state.lastId = id; refresh(); }
    }, 300);

    state.lastId = idField ? idField.value : null;
    refresh();
    return state;
  }

  // Capture phase on document: runs before the theme's own add-to-cart handlers.
  // Only takes over when at least one add-on box is ticked.
  function intercept(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var form = target.closest('form');
    if (!form) return;

    var state = null;
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].form === form) { state = roots[i]; break; }
    }
    if (!state) return;

    if (e.type === 'click' && !target.closest('[data-add-to-cart]')) return;
    if (e.type === 'submit' && e.submitter && !e.submitter.matches('[data-add-to-cart]')) return;

    if (state.checkedBoxes().length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    state.addAll();
  }

  function boot() {
    var found = document.querySelectorAll('[data-oil-pan-addons]');
    for (var i = 0; i < found.length; i++) {
      var s = init(found[i]);
      if (s) roots.push(s);
    }
    if (roots.length) {
      document.addEventListener('click', intercept, true);
      document.addEventListener('submit', intercept, true);
    }
  }

  window.RemtuneOilPanAddons = { _roots: roots, _boot: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
